import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { CopyInput } from 'foundations-components/transitional/components/CopyInput';
import { Text } from 'foundations-components/components/Text';
import { getCommerceHomeUrl, getWebsitesURL } from 'growth-payments-core/urls/urls';
import Confetti from 'growth-onboarding-confetti/Confetti';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UseCaseTourCompleteModal = ({
  onClose,
  websiteLink
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "useCaseTourCompleteModal",
    use: "conversational",
    width: 500,
    onEsc: onClose,
    children: [/*#__PURE__*/_jsx(Confetti, {
      pieces: 60
    }), /*#__PURE__*/_jsx(DialogHeaderImage, {
      offsetTop: 120,
      children: /*#__PURE__*/_jsx(Illustration, {
        name: "success"
      })
    }), /*#__PURE__*/_jsxs(DialogHeader, {
      paddingBlockStart: "100",
      paddingBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        "data-test-id": "useCaseTourCompleteModal-close",
        onClick: onClose
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "useCaseTourCompleteModal.header"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsxs(Text, {
        as: "div",
        textAlign: "start",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "useCaseTourCompleteModal.messagePublished"
        }), /*#__PURE__*/_jsx(Text, {
          paddingBlockStart: "200",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "useCaseTourCompleteModal.messageFindAll_jsx",
            options: {
              href: getWebsitesURL(),
              external: true
            },
            elements: {
              Link
            }
          })
        }), /*#__PURE__*/_jsxs(Text, {
          as: "div",
          paddingBlockStart: "500",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "useCaseTourCompleteModal.shareLink.message"
          }), /*#__PURE__*/_jsx(CopyInput, {
            value: websiteLink,
            marginBlockStart: "200"
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(TFlex, {
        align: "center",
        justify: "center",
        direction: "column",
        wrap: "wrap",
        children: /*#__PURE__*/_jsx(Link, {
          "data-test-id": "useCaseTourCompleteModal-backToGuide",
          href: getCommerceHomeUrl(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "useCaseTourCompleteModal.backToCommerce"
          })
        })
      })
    })]
  });
};
export default UseCaseTourCompleteModal;